/**
 * эмуляция формата из src/components/table/table.vue
 * @param dataValue{Object}
 * @param fieldName{String}
 * @param fieldMeta{Object}
 * @returns {string}
 */
export function transformTableFieldValueToString (dataValue, fieldName, fieldMeta) {
  if (typeof dataValue[fieldName] === 'boolean') {
    return dataValue[fieldName] ? 'Да' : 'Нет'
  } else if (typeof(dataValue[fieldName]) !== 'object') {
    return dataValue[fieldName]
  } else if (Array.isArray(dataValue[fieldName])) {
    return dataValue[fieldName].map(v => v.name).join(', ')
  } else if (dataValue[fieldName] && fieldMeta.path) {
    return dataValue[fieldName][fieldMeta.path]
  } else if (dataValue[fieldName] && dataValue[fieldName].name) {
    return dataValue[fieldName].name
  }
  return ''
}
